export default __webpack_public_path__ + "static/media/sponsor_300x250.4470ae0d.png";